<template>
  <div>
    <!--Header-->
    <div id="valuation" class="header bg-home pt-5">
      <div class="container">
        <div class="header-body">
          <div class="row align-items-center">
            <div class="col-lg-6 mb-7">
              <div class="mt-6 mb-4">
                <h3 class="text-white"><b style="font-size: 2rem">{{ userData.fullName }}</b><br />O resultado do seu <br />teste de Perfil Empreendedor é:</h3>
                <div class="mt-5 mb-3">
                  <div class="valuation-box mb-2">
                    <h1 class="display-1 text-white font-weight-bold">{{ result }}</h1>
                  </div>
<!--                  <small>*Valuation Pré-Money</small>-->
                </div>
              </div>
<!--              <div class="btn-header mt-2 pt-2">-->
<!--                <router-link to="/intro" class="btn btn-neutral my-2">Compartilhar Resultado</router-link>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 860 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="860 0 860 100 0 100"></polygon>
        </svg>
      </div>

    </div>

    <section>
      <div class="container">
        <div class="explain mt-4">
          <h2 class="display-3">O que isso significa?
            <br />
            <br />
            <span class="text-success">{{ resultTitle }}</span>
          </h2>


          <p class="lead mt-5">{{ resultText }}</p>

        </div>

        <button @click="sendWhatsapp()" class="share follow-button mt-7 mb-5">
          <div class="follow-content">
            <i class="fab fa-whatsapp"></i>
            <h4>Compartilhar Resultado</h4>
          </div>
        </button>

        <button @click="joinTelegram" v-if="this.telegram === false" class="telegram share follow-button mb-5">
          <div class="follow-content">
            <i class="fab fa-telegram"></i>
            <h4>Entre no Grupo do Telegram</h4>
          </div>
        </button>

        <button @click="subscribeYoutube" v-if="this.youtube === false" class="youtube share follow-button mb-5">
          <div class="follow-content">
            <i class="fab fa-youtube"></i>
            <h4>Inscreva-se no canal</h4>
          </div>
        </button>

      </div>
    </section>
    <!-- Page content -->



  </div>
</template>
<script>
  import { Tooltip } from 'element-ui'
  import { Select, Option } from 'element-ui'
  import requestZapier from "../../plugins/requestZapier";
  import db from "../../plugins/firebase.js"

  export default {
    name: 'valuation',
    data: () => ({
      feedback: false,
      feedbackMessage: '',
      userData: {},
      modals: {
        question: false,
      }
    }),
    methods: {
      joinTelegram () {
        window.open('https://t.me/davibraga', '_blank')
      },
      subscribeYoutube () {
        window.open('https://youtube.com/davibraga', '_blank')
      },
      sendWhatsapp () {
        let content = 'Meu resultado no teste Perfil Empreendedor do Davi Braga foi ' + this.result + '. Isso quer dizer que sou um ' + this.resultTitle +
          '. Que tal fazer o seu teste também? É só acessar https://seuperfilempreendedor.web.app'
        let link = 'https://api.whatsapp.com/send?text=' + content
        window.open(link, '_blank')
      }
    },
    computed: {
      result: function () {
        return this.$route.params.result
      },
      resultText: function () {
        return this.$route.params.text
      },
      resultTitle: function () {
        return this.$route.params.title
      },
      telegram: function () {
        return this.$route.params.telegram
      },
      youtube: function () {
        return this.$route.params.youtube
      }
    },
    components: {
      [Tooltip.name]: Tooltip,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    created() {
      let userPayload = window.localStorage.getItem("userData")

      if (userPayload != null) {
        this.userData = JSON.parse(userPayload)
      }
      window.localStorage.clear()
    }
  };
</script>
